import { $tracing } from '../tracing';

export const tgBindNotBotName = () => {
  $tracing.addEvent({
    t: 'not telegram bot name',
    ext: {
      href: window?.location?.href,
    },
  });
};
